import { render, staticRenderFns } from "./Screenshot.vue?vue&type=template&id=4e8f7ac5"
import script from "./Screenshot.vue?vue&type=script&lang=js"
export * from "./Screenshot.vue?vue&type=script&lang=js"
import style0 from "./Screenshot.vue?vue&type=style&index=0&id=4e8f7ac5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports